<template>
  <section class="industry-form">
    <catering-form
      v-show="type === 2001"
      ref="catering-form"
      :form="form"
      @getFormData="handlerGetFormData" />
    <pure-form
      v-show="type === 2101"
      ref="pure-form"
      :form="form"
      @getFormData="handlerGetFormData" />
    <retail-form
      v-show="type === 2201"
      ref="retail-form"
      :form="form"
      @getFormData="handlerGetFormData" />
    <beauty-form
      v-show="type === 2301"
      ref="beauty-form"
      :form="form"
      @getFormData="handlerGetFormData" />
    <education-form
      v-show="type === 2401"
      ref="education-form"
      :form="form"
      @getFormData="handlerGetFormData" />
    <hair-form
      v-show="type === 2501"
      ref="hair-form"
      :form="form"
      @getFormData="handlerGetFormData" />
    <warehouse-form
      v-show="type === 2601"
      ref="warehouse-form"
      :form="form"
      @getFormData="handlerGetFormData" />
    <medical-form
      v-show="type === 2701"
      ref="medical-form"
      :form="form"
      @getFormData="handlerGetFormData" />
  </section>
</template>
<script>
import CateringForm from './catering-form'
import PureForm from './pure-form'
import RetailForm from './retail-form'
import BeautyForm from './beauty-form'
import EducationForm from './education-form'
import HairForm from './hair-form'
import WarehouseForm from './warehouse-form'
import MedicalForm from './medical-form'
export default {
  name: 'NewIndustryForm',
  components: {
    CateringForm,
    PureForm,
    RetailForm,
    BeautyForm,
    EducationForm,
    HairForm,
    WarehouseForm,
    MedicalForm
  },
  props: {
    type: {
      type: [String, Number],
      default: ''
    },
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
        
    }
  },
  methods: {
    submitForm() {
      const form = {
        2001: 'catering-form',
        2101: 'pure-form',
        2201: 'retail-form',
        2301: 'beauty-form',
        2401: 'education-form',
        2501: 'hair-form',
        2601: 'warehouse-form',
        2701: 'medical-form',
      }
      this.$refs[form[this.type]].submitForm()
    },
    handlerGetFormData(data) {
      this.$emit('getFormData', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.industry-form {
    height: 100%;
}
</style>